module.exports = __webpack_public_path__ + "static/media/Sun.ee9e8e01.svg";